"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScheduleReminders = exports.useUploadInvitations = exports.useDownloadServiceStats = void 0;
var sync_1 = require("csv-parse/browser/esm/sync");
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var firestore_1 = require("firebase/firestore");
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var backend_1 = require("utils/backend");
var dateTime_1 = require("utils/dateTime");
var fieldProcessors_1 = require("utils/fieldProcessors");
var single_1 = require("utils/selectors/single");
var useDownloadServiceStats = function (companyId) {
    var firebaseInstance = (0, react_redux_firebase_1.useFirebase)();
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    return [
        function () { return __awaiter(void 0, void 0, void 0, function () {
            var serviceStatsQuerySnapshot, serviceStatsPromises, serviceStats, header, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 4, 5]);
                        return [4 /*yield*/, firebaseInstance.firestore().collection('service_stats')
                                .where('companyId', '==', companyId).get()];
                    case 2:
                        serviceStatsQuerySnapshot = _a.sent();
                        serviceStatsPromises = serviceStatsQuerySnapshot.docs.map(function (doc) { return __awaiter(void 0, void 0, void 0, function () {
                            var serviceId, expenditures, flattenedExpenditures, transactionsCount, totalSpend, serviceDoc;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        serviceId = doc.get('serviceId');
                                        expenditures = doc.get('expenditures');
                                        flattenedExpenditures = expenditures && Object.values(expenditures).map(function (year) { return Object.values(year || {}); }).flat(2);
                                        transactionsCount = (flattenedExpenditures === null || flattenedExpenditures === void 0 ? void 0 : flattenedExpenditures.length) || 0;
                                        totalSpend = flattenedExpenditures
                                            ? (0, sumBy_1.default)(flattenedExpenditures, function (t) { return t.amount; }) || 0
                                            : 0;
                                        return [4 /*yield*/, firebaseInstance.firestore().collection('services').doc(serviceId).get()];
                                    case 1:
                                        serviceDoc = _a.sent();
                                        return [2 /*return*/, [serviceId, serviceDoc.get('name'), totalSpend, transactionsCount, doc.get('isSoftDelete')]];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(serviceStatsPromises)];
                    case 3:
                        serviceStats = _a.sent();
                        serviceStats.sort(function (a, b) { return b[2] - a[2]; });
                        header = ['serviceId', 'serviceName', 'totalSpend', 'transactionsCount', 'isSoftDelete'];
                        data = CSV.stringify(__spreadArray([header], __read(serviceStats), false));
                        (0, fieldProcessors_1.saveAsCSV)(data, 'service_stats.csv');
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); },
        isLoading,
    ];
};
exports.useDownloadServiceStats = useDownloadServiceStats;
var useUploadInvitations = function () {
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    return [
        isLoading,
        function (invitationscsvString) { return __awaiter(void 0, void 0, void 0, function () {
            var invitations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        invitations = (0, sync_1.parse)(invitationscsvString);
                        return [4 /*yield*/, (0, backend_1.callBackendFn)('invitations-uploadInvitationsCsv')({ invitations: invitations })];
                    case 1:
                        _a.sent();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); },
    ];
};
exports.useUploadInvitations = useUploadInvitations;
var useScheduleReminders = function (templateSelection) {
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var _b = __read((0, react_1.useState)(null), 2), error = _b[0], setError = _b[1];
    var firebaseInstance = (0, react_redux_firebase_1.useFirebase)();
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var firstFollowUpEmailDate = firestore_1.Timestamp.fromDate((0, dateTime_1.addDays)(new Date(), 7));
    var secondFollowUpEmailDate = firestore_1.Timestamp.fromDate((0, dateTime_1.addDays)(new Date(), 14));
    // TEST Only
    // 5 minutes interval between every email follow-ups
    var testFirstFollowUpEmailDate = firestore_1.Timestamp.fromDate((0, dateTime_1.addMinutes)(new Date(), 5));
    var testSecondFollowUpEmailDate = firestore_1.Timestamp.fromDate((0, dateTime_1.addMinutes)(new Date(), 10));
    return [
        isLoading,
        function (csvString) { return __awaiter(void 0, void 0, void 0, function () {
            var invitations, promises, sequence;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        setError(null);
                        invitations = (0, sync_1.parse)(csvString);
                        promises = [];
                        sequence = [];
                        if (templateSelection.invitationUnopenedReminder) {
                            sequence.push({
                                order: 1,
                                template: 'invitationUnopenedReminder',
                                scheduledAt: templateSelection.isTesting ? testFirstFollowUpEmailDate : firstFollowUpEmailDate,
                            });
                        }
                        if (templateSelection.completionRateZeroReminder) {
                            sequence.push({
                                order: 2,
                                template: 'completionRateZeroReminder',
                                scheduledAt: templateSelection.isTesting ? testFirstFollowUpEmailDate : firstFollowUpEmailDate,
                            });
                        }
                        if (templateSelection.finalReminder) {
                            sequence.push({
                                order: 3,
                                template: 'finalReminder',
                                scheduledAt: templateSelection.isTesting ? testSecondFollowUpEmailDate : secondFollowUpEmailDate,
                            });
                        }
                        if (templateSelection.initialInvitation) {
                            promises.push((0, backend_1.callBackendFn)('invitations-uploadReviewInvitationsCsv')({
                                invitations: invitations,
                                companyId: profile === null || profile === void 0 ? void 0 : profile.companyId,
                            }).catch(function (e) {
                                setError(e);
                                setIsLoading(false);
                            }));
                        }
                        return [4 /*yield*/, Promise.all(__spreadArray(__spreadArray([], __read(promises), false), [
                                firebaseInstance.firestore().collection('email_reminders').add({
                                    parsedCSV: csvString,
                                    companyId: profile === null || profile === void 0 ? void 0 : profile.companyId,
                                    sequence: sequence,
                                }),
                            ], false))];
                    case 1:
                        _a.sent();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); },
        error,
    ];
};
exports.useScheduleReminders = useScheduleReminders;
